import script from "./EditProfile.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditProfile.vue?vue&type=script&setup=true&lang=ts"

import "./editProfile.scss?vue&type=style&index=0&id=5f524932&scoped=true&lang=css&external"
import "./EditProfile.vue?vue&type=style&index=1&id=5f524932&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f524932"]])

export default __exports__